module.exports = __webpack_public_path__ + "img/hr-concrete-hole-decal-22.22361bb5.png";